import { useState } from "react";
import { useLanguage } from "@/i18n/LanguageContext";

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqSectionProps {
  items: FaqItem[];
  heading?: string;
}

export default function FaqSection({ items, heading }: FaqSectionProps) {
  const { t } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="bg-white py-16 md:py-20">
      <div className="max-w-[1080px] mx-auto px-4 md:px-6">
        <h2 className="text-center text-2xl md:text-[32px] font-bold text-emerald-800 mb-10 md:mb-12">
          {heading || t("common.faqHeading")}
        </h2>
        <div className="space-y-4">
          {items.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={idx}
                className="bg-[#fefce8] rounded-xl p-4 md:p-6 transition-all duration-200"
              >
                <button
                  type="button"
                  onClick={() => toggle(idx)}
                  className="w-full flex items-center justify-between gap-4 text-left cursor-pointer group"
                >
                  <span className="text-base md:text-lg font-bold text-emerald-800">
                    {item.question}
                  </span>
                  <span className="flex items-center justify-center w-8 h-8 flex-shrink-0">
                    <i
                      className={`ri-arrow-down-s-line text-xl text-emerald-700 transition-transform duration-200 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    />
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? "max-h-96 mt-3 md:mt-4" : "max-h-0"
                  }`}
                >
                  <p className="text-[15px] leading-relaxed text-gray-700">
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}